<div class="timer-countdown__wrapper">
    <p class="mat-headline-3">{{ timeString }}</p>
    <p>remaining</p>
</div>
